import { render, staticRenderFns } from "./EditPushMessage.vue?vue&type=template&id=5f97d23d&"
import script from "./EditPushMessage.vue?vue&type=script&lang=js&"
export * from "./EditPushMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports